import { put, call } from 'redux-saga/effects';
import { loginUserService, logoutUserService, emailVerificationService, setPasswordService, loginClientAffiliateList, forgotPassword, resetPasswordVerify } from '../services/authenticationService';

import * as types from '../actions';

export function* loginSaga(payload) {
  try {
    const response = yield call(loginUserService, payload);
    yield put({ type: types.LOGIN_USER_SUCCESS, response })
    
  } catch(error) {
    yield put({ type: types.LOGIN_USER_ERROR, error })
  }
}

export function* logoutSaga(payload) {
  try {
    const response = yield call(logoutUserService, payload);
    yield put({ type: types.LOGOUT_USER_SUCCESS, response })
    
  } catch(error) {
    yield put({ type: types.LOGOUT_USER_ERROR, error });
  }
}

// export function* forgotPasswordSaga(payload) {
//   try {
//     const response = yield call(forgotPasswordService, payload);
//     yield [
//       put({ type: types.FORGOT_PASSWORD_SUCCESS, response })
//     ];
//   } catch(error) {
//     yield put({ type: types.FORGOT_PASSWORD_ERROR, error });
//   }
// }

export function* emailVerificationSaga(payload) {
  try {
    const response = yield call(emailVerificationService, payload);
    yield put({ type: types.EMAIL_VERIFICATION_SUCCESS, response })
    
  } catch(error) {
    yield put({ type: types.EMAIL_VERIFICATION_ERROR, error });
  }
}

export function* setPasswordSaga(payload) {
  try {
    const response = yield call(setPasswordService, payload);
    yield put({ type: types.SET_PASSWORD_SUCCESS, response })
    
  } catch(error) {
    yield put({ type: types.SET_PASSWORD_ERROR, error });
  }
}

export function* loginClientAffiliateListSaga(payload) {
  try {
    const response = yield call(loginClientAffiliateList, payload);
    yield put({ type: types.LOGIN_CLIENT_AFFILIATE_LIST_SUCCESS, response })
    
  } catch(error) {
    yield put({ type: types.LOGIN_CLIENT_AFFILIATE_LIST_ERROR, error });
  }
}

export function* forgotPasswordSaga(payload) {
  try {
    const response = yield call(forgotPassword, payload);
    yield put({ type: types.FORGOT_PASSWORD_SUCCESS, response })
    
  } catch(error) {
    yield put({ type: types.FORGOT_PASSWORD_ERROR, error })
  }
}

export function* resetPasswordVerifySaga(payload) {
  try {
    const response = yield call(resetPasswordVerify, payload);
    yield put({ type: types.RESET_PASSWORD_VERIFICATION_SUCCESS, response })
    
  } catch(error) {
    yield put({ type: types.RESET_PASSWORD_VERIFICATION_ERROR, error })
  }
}